import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  benefitsText: {
    fontSize: 20,
    color: '#212121',
    margin: 4,
  },
  benefitsPurple: {
    fontSize: 24,
    color: '#7833FF',
    fontWeight: 'bold',
    margin: 5,
    lineHeight: 1.4,
  },
  subTitlePurple: {
    fontSize: 30,
    color: '#7833FF',
    fontWeight: 'bold',
  },
  btnPharmaceutical: {
    [theme.breakpoints.down('md')]: {
      display: 'grid',
      justifyContent: 'center',
      paddingBottom: 10,
    },
  },
  sectionCheck: {
    background: 'linear-gradient(180deg, #DC1866 0%, #E73E52 31%, #FF9226 100%)',
  },
  titleWhite: {
    fontSize: 30,
    color: '#FFFFFF',
    fontFamily: 'Lato',
    fontWeight: 'bold',
    padding: '30px 0px',
  },
  btnWhite: {
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    backgroundColor: '#FFFFFF',
    borderRadius: 40,
    color: '#7833FF',

    '&:hover': {
      backgroundColor: '#E0E0E0',
    },
  },
}));
